import React from 'react';
import Modal from 'react-bootstrap/Modal';
import GooglePlacesDropdown from './GooglePlaces';
import { AddressDetails } from './models/JobInterfaces';

interface JobQuoteExtraItemProps {
    isEvent: boolean;
    existDeliveryAddress: string;
    extras: NewJobQuoteItemExtra;
    extraItemOptions: JobQuoteExtraItemOption[];
    itemDescription: string;
    itemTableDesk: number;      //number of tables/desks the item comes with
    itemChairs: number;         //number of chairs the item comes with
    readonly: boolean;
    showModal: boolean;
    hideModal(): void;
    update(extras: NewJobQuoteItemExtra): void;
    save(deliveryAddress: DeliveryAddress): void;
}

interface NewJobQuoteItemExtra {
    itemId: number;
    quantity: number;
    equipped: boolean;
}

interface JobQuoteExtraItemOption {
    id: number;
    name: string;
    tableDesk: number;
    chairs: number;
}

interface DeliveryAddress {
    deliveryAddress: string;
    deliveryAddressGooglePlaceId: string;
    deliveryAddressLatitude: number;
    deliveryAddressLongitude: number;
};

const JobQuoteExtraItemModal = (props: JobQuoteExtraItemProps) => {
    const [googleAddress, setGoogleAddress] = React.useState<DeliveryAddress>({
        deliveryAddress: "",
        deliveryAddressGooglePlaceId: "",
        deliveryAddressLatitude: 0,
        deliveryAddressLongitude: 0
    });

    const handleChange = (e: any) => {
        //update item that has changed
        var item = props.extras;
        item.quantity = e.target.value * 1;

        props.update(item);
    }

    const hideModal = () => {
        props.hideModal();
    }

    const setAddress = async (addressDetails: AddressDetails) => {
        setGoogleAddress(prevState => ({
            ...prevState,
            deliveryAddress: addressDetails.fullAddress,
            deliveryAddressGooglePlaceId: addressDetails.placeId,
            deliveryAddressLatitude: addressDetails.latitude,
            deliveryAddressLongitude: addressDetails.longitude
        }));
    }

    const save = (e: any) => {
        e.preventDefault();

        props.save(googleAddress);
    }
    
    const extraItem = props.extraItemOptions.find(i => i.id == props.extras.itemId);
    const tables = extraItem ? extraItem.tableDesk : 1;
    const chairs = extraItem ? extraItem.chairs : 2;
    const googleContents = <GooglePlacesDropdown addressId="autocomplete" addressLabel={"Deivery Address"} placeholder={props.existDeliveryAddress} className="input-group" useLargeLabel={false} afterValid={setAddress} />

    return (
        <div>
            <Modal show={props.showModal} onHide={hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Add extra Table/Desk and Chairs</Modal.Title>
                    <button type="button" className="close" onClick={hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <label className="input-group">
                            <span className="label">Base Unit Includes</span>
                            <span>{props.itemDescription}</span>
                        </label>
                        <hr></hr>
                        <label className="input-group" htmlFor="itemId">
                            <span className="label">Extra Type</span>
                            <select className="select" value={props.extras.itemId} disabled>
                                <option hidden defaultValue="-1"></option>
                                {props.extraItemOptions.map(item =>
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                )};
                            </select>
                        </label>

                        <label className="input-group" htmlFor="quantity">
                            <span className="label">Quantity</span>
                            <input className="input" min={0} type="number" id="quantity" name="quantity" value={props.extras.quantity} onChange={(e) => handleChange(e)} disabled={props.readonly}></input>
                        </label>

                        <label className="input-group " htmlFor="equipped">
                            <span className="label">Equipped?</span>
                            <input type="checkbox" name="equipped" id="equipped" checked={props.extras.equipped} disabled></input>
                        </label>

                        <label className="input-group">
                            <span className="label">Unit Includes</span>
                            <span>{props.extras.quantity === 0 ? props.itemDescription : ((tables * props.extras.quantity) + props.itemTableDesk) + (props.extras.itemId == 52 ? " tables, " : " desks, ") + ((chairs * props.extras.quantity)  + props.itemChairs) + " chairs and air conditioning"}</span>
                        </label>
                        <div className={props.extras.equipped ? "marginLeftLabel" : "hidden"}>Small fridge, microwave and hot water unit</div>
                        
                        <div className={props.isEvent ? "" : "hidden"}>
                            <hr></hr>
                            <div>Enter Delivery Address ONLY IF DIFFERENT from Site Address</div>
                            {googleContents}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className={props.readonly ? "hidden" : "popup-button--yes"} onClick={save}>Calculate</button>
                    <button className={props.readonly ? "popup-button--yes" : "hidden"} onClick={hideModal}>Close</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default JobQuoteExtraItemModal;